import { Box, Flex } from '@chakra-ui/react';
import React, { useMemo } from 'react';

import { ListLoader } from '@app/screens/pools/components/ListLoader';

import s from './PositionsList.module.scss';
import { useVaultsPositions } from '@app/hooks/plugins/useVaultsPositions';
import { VaultsPositionsListRow } from '@app/screens/positions/components/VaultsPositionsListRow';
import { useAllProvidersVaults } from '@app/hooks/pools/useAllProvidersVaults';

export const VaultsPositionsList = () => {
  const { data: vaults } = useAllProvidersVaults();
  const { data, isLoading } = useVaultsPositions({
    ids: vaults?.map(vault => vault.lpToken.id)
  });

  const positions = useMemo(() => {
    if (!vaults || !data) {
      return [];
    }

    const _vaults = vaults.filter(v => data.some(d => d.id === v.lpToken.id));

    return _vaults.map(vault => {
      const position = data.find(d => d.id === vault.lpToken.id);

      const params = {
        totalSupply: position?.totalSupply,
        token0: position?.token0,
        token1: position?.token1,
        balance: position?.balance,
        totalAmounts: position?.totalAmounts,
        apr: vault.apr,
        vault
      };

      return <VaultsPositionsListRow data={params} key={vault.lpToken.id} />;
    });
  }, [data, vaults]);

  return (
    <Box
      p={[0, '0 24px 24px']}
      borderRadius="16px"
      bg={['transparent', 'gray.3']}
      border={['none', '1px solid #232323']}
      mb={4}
    >
      <Box className={s.container}>
        <div className={s.header}>
          <Flex width="20%">Pool</Flex>
          <Flex width="15%">Provider</Flex>
          <Flex width="10%">Amount</Flex>
          <Flex width="10%">Composition</Flex>
          <Flex width="5%">APR</Flex>
          <Flex width="25%">&nbsp;</Flex>
        </div>
        {isLoading ? <ListLoader /> : positions}
      </Box>
    </Box>
  );
};
